const dict = {
  LANGUAGE_LABEL: {
    message: ' Deutsch',
  },
  MATRIX_DIMENSIONS_ERROR: {
    message: `Memory puzzle matrix mindestens 2x2,
      oder maximal 10x10 Abmessungen haben. Wie zum Beispiel: `,
  },
  LOADING: {
    message: 'Wird geladen...',
  },
  ENTER_YOUR_NAME: {
    message: 'Name eingeben',
  },
  PLAYERS_NAME: {
    message: 'Spielername',
  },
  COLUMNS: {
    message: 'Spalte',
  },
  ROWS: {
    message: 'Reihe',
  },
  SELECT_LANGUAGE: {
    message: 'Wähle deine Sprache',
  },
  FULL_SCREEN: {
    message: 'Vollbildmodus',
  },
  APPLY: {
    message: 'Anwenden',
  },
  RESTART: {
    message: 'Neustart',
  },
  PLAY: {
    message: 'Spielen',
  },
  CONTINUE: {
    message: 'Weiter',
  },
  CHALLENGE: {
    message: 'Challenge',
  },
};

export default dict;
